import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useMemo, useState } from 'react';
import { EyeFill } from '../../icons/EyeFill';
import { getTestIds } from '../../utils/TestIds';
import { PasswordStrengthMeter } from '../PasswordStrengthMeter';
import { TextField } from '../TextField';
import styles from './PasswordField.module.scss';
export const GetPasswordFieldTID = (parentTestId)=>getTestIds(parentTestId);
export const PasswordField = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { showStrengthMeter, strengthScore } = _ref1, props = _object_without_properties(_ref1, [
        "showStrengthMeter",
        "strengthScore"
    ]), [ref] = _rest;
    const [showPassword, setShowPassword] = useState(false);
    const testIds = useMemo(()=>GetPasswordFieldTID(props.testId), [
        props.testId
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.root,
        "data-testid": testIds.PasswordFieldTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(TextField, _object_spread({
                collapseHelperText: false,
                ref: ref,
                type: showPassword ? 'text' : 'password',
                suffix: /*#__PURE__*/ _jsx("span", {
                    className: styles.eye,
                    onClick: ()=>setShowPassword(!showPassword),
                    children: /*#__PURE__*/ _jsx(EyeFill, {})
                }),
                label: "Password"
            }, props)),
            showStrengthMeter && /*#__PURE__*/ _jsx(PasswordStrengthMeter, {
                score: strengthScore !== null && strengthScore !== void 0 ? strengthScore : null,
                testId: testIds.PasswordFieldTestIds.StrengthMeter()
            })
        ]
    });
});
